<template>
  <div class="row">
    <div
      v-if="props.deal.hasCustomProperties"
      class="col-12">
      <div class="row">
        <div class="col-12">
          <div class="pane-header">
            <span class="icon"><icon-colored-settings /></span>
            <span>{{ capitalize($t('names.customProperty', { n: 2 })) }}</span>
          </div>
        </div>
        <div class="col-12">
          <div class="pane-content">
            <div class="row">
              <div class="col-12">
                <ul>
                  <li
                    v-for="prop in props.deal.packageCustomProperties"
                    :key="prop.label">
                    <h4>{{ prop.label }}</h4>
                    <span class="text-muted">
                      {{ prop.value.name }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize } from 'vue';

  import { IconColoredSettings } from '@/common/icons/colored';
  import { Package } from '@/common/models';

  interface IDealDetailsCustomPropertiesProps {
    deal: Package;
  }

  const props = defineProps<IDealDetailsCustomPropertiesProps>();
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
